import React, { ChangeEvent } from "react";
import Table from "../Table";
import { CONSTANTS } from "../../constants/Constants";
import ExperienceModal from "../ExperienceModal";
import Button from "../Buttons";
import moment from "moment";

interface ExperienceProps {
  payload: any;
  expChangeHandler: (e: ChangeEvent, journey: string) => void;
  saveExpHandler: () => void;
  countryOptions: {}[];
  cityOptions: {}[];
  changeLocationHandler: (
    e: ChangeEvent<HTMLSelectElement>,
    state?: "experience"
  ) => void;
  isModalOpen: boolean;
  setIsModalOpen: any;
  setCurrentItemIndex: any;
  setNewExp: any;
  newExp: any;
  cityError: string
}

const Experience: React.FC<ExperienceProps> = ({
  payload,
  expChangeHandler,
  saveExpHandler,
  countryOptions,
  cityOptions,
  changeLocationHandler,
  isModalOpen,
  setIsModalOpen,
  setCurrentItemIndex,
  setNewExp,
  newExp,
  cityError
}) => {

  const filteredRows = payload?.[
    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_EXPERIENCE
  ]?.map((exp: any) => {
    return {
      imageUrl:
        exp[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.IMAGE_URL],
      company:
        exp[
        CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ORGANIZATION_NAME
        ],
      title: exp[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.TITLE],
      location: `${exp.city || ""}${exp.country ? `, ${exp.country}` : ""}`,
      startedOn: exp[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STARTED_ON] ? moment(
        exp[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STARTED_ON]
      ).format("MMM-YYYY") : '',
      endedOn: exp[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ENDED_ON]
        ? moment(
          exp[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ENDED_ON]
        ).format("MMM-YYYY")
        : "",
      status: exp[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STATUS],
    };
  });
  return (
    <>
      <div className="lg:p-6">
        <h2 className="text-2xl font-semibold mb-4">
          {CONSTANTS.EXPERIENCE_HEADING_TXT}
        </h2>
        <div className="overflow-auto">

          <Table
            tableHeader={filteredRows.length > 0 ? [
              "",
              CONSTANTS.COMPANY_TXT,
              CONSTANTS.TITLE_TXT,
              CONSTANTS.LOCATION_TXT,
              CONSTANTS.STARTED_ON_TXT,
              CONSTANTS.ENDED_ON_TXT,
              CONSTANTS.SHOW_ON_PROFILE_TXT,
            ] : []}
            tableRows={filteredRows}
            draggable={false}
            rowClickHandler={(index) => {
              setNewExp(
                payload[
                CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                  .RESOURCE_EXPERIENCE
                ][index]
              );
              setCurrentItemIndex(index);
              setIsModalOpen(true);
            }}
          />
        </div>
        <div className="w-32 mt-4">
          <Button
            btn_label={CONSTANTS.ADD_MORE}
            on_click_handler={() => {
              setNewExp({
                status: CONSTANTS.ENABLED_TXT.toLocaleUpperCase(),
              });
              setCurrentItemIndex(null);
              setIsModalOpen(true);
            }}
            other_classes="!rounded"
          />
        </div>
      </div>

      {isModalOpen && (
        <ExperienceModal
          payload={newExp}
          countryOptions={countryOptions}
          cityOptions={cityOptions}
          changeLocationHandler={changeLocationHandler}
          expChangeHandler={expChangeHandler}
          saveExpHandler={saveExpHandler}
          setIsModalOpen={setIsModalOpen}
          cityError={cityError}
        />
      )}
    </>
  );
};

export default Experience;
